<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.isPageActionLoaded() && localService.languageContent && localService.languageContent.table">
  <div *ngIf="!localService.isPageAllowed()">
    <app-full-page-message></app-full-page-message>
  </div>
  <div *ngIf="localService.isPageAllowed()">
    <div class="banner center" style="max-width:800px;" *ngIf="wrappers">
      <div class="row row_header">
        <div class="col-2">
          {{localService.languageContent.table.action}}
        </div>
        <div class="col-5">
          {{localService.languageContent.table.language}}
        </div>
        <div class="col-5">
          {{localService.languageContent.table.words}}
          <div class="icon_action_header">
            <button class="button_icon button_icon_color" style="margin-right: 5px;"
            (click)="onAction(4)">g_translate</button>
            <i class="material-icons" (click)="loadLanguages()">refresh</i>
            <i class="material-icons" *ngIf="localService.isActionAllowed(1)" (click)="openLanguage('')" title="{{localService.languageContent.common.add}}">note_add</i>
            <i class="material-icons button" (click)="onAction(3)">file_download</i>
            <app-file-upload [fileUploadFor]="FileUploadFor.MissedLanguage"></app-file-upload>
            <button class="button_icon button_icon_color" (click)="onAction(5)">search</button>
          </div>
        </div>
      </div>
      <div>
        <div class="row styled_row" *ngFor="let item of wrappers">
          <div class="col-2">
            <i *ngIf="localService.isActionAllowed(7)" class="material-icons button active_icon" title="{{item.v3 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v3 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v3 == '1' ? "toggle_on" : "toggle_off"}}</i>
            <i class="material-icons button icon_adjust" (click)="onAction(2,item.key)">file_download</i>
            <i class="material-icons button delete_icon icon_adjust" *ngIf="item.v1 != 'en'" (click)="onAction(6,item.key)">delete_forever</i>
          </div>
          <div class="col-5 {{item.v1}}">
            <span class="en">{{item.v1}}&nbsp;</span>
            <span class="button" *ngIf="localService.isActionAllowed(2)" (click)="openLanguage(item.key)">{{item.v2}}</span>
            <span *ngIf="!localService.isActionAllowed(2)">{{item.v2}}</span>
          </div>
          <div class="col-5">
            <i class="material-icons button icon_adjust" *ngIf="item.v4 != '100.00'" (click)="onAction(4,item.key)">g_translate</i>
            <i class="material-icons button icon_adjust" *ngIf="item.v4 != '100.00' && !localService.isHideDummy" (click)="onAction(1,item.key)">file_download</i>
            <app-progress-bar [value]="item.v4" [reduceWidth]="item.v4 != '100.00' ? 30 : 0" [isAnimation]="!isAutoRefreshEnabled"></app-progress-bar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
